import { useSkipassStore } from "@/store/skipassStore"

const BASE_IMAGE_URL = "/sv/boka-online/accommodation/image/get?imageId="

const SRCSET_SIZES = [
  { width: 180, alias: 20 },
  { width: 360, alias: 22 },
  { width: 768, alias: 24 },
  { width: 1024, alias: 26 },
  { width: 1280, alias: 28 },
  { width: 1440, alias: 30 },
] as const

const useResponsiveImage = (
  imageId: number,
  options?: { maxSize?: boolean }
) => {
  const hostConfig = useSkipassStore((state) => state.hostConfig)
  const media = hostConfig?.media

  const imageSizeAlias = options?.maxSize ? 26 : 4
  const relativeImageUrl = `${BASE_IMAGE_URL}${imageId}&ImageSize=${imageSizeAlias}&keepRatio=true`
  const imageUrl = media ? `${media}${relativeImageUrl}` : relativeImageUrl

  const srcSet = options?.maxSize
    ? undefined
    : SRCSET_SIZES.map(({ width, alias }) => {
        const url = `${BASE_IMAGE_URL}${imageId}&ImageSize=${alias}&keepRatio=true`
        return `${media ? `${media}${url}` : url} ${width}w`
      }).join(", ")

  return {
    imageUrl,
    srcSet,
  }
}

export default useResponsiveImage
